import type { LinkCategory } from '../types'
import BrandIcon from './BrandIcon'

const STYLES: Record<LinkCategory, { color: string; label: string }> = {
  youtube:   { color: 'var(--color-cat-youtube)',   label: 'YouTube' },
  twitter:   { color: 'var(--color-cat-twitter)',   label: 'Twitter' },
  tiktok:    { color: 'var(--color-cat-tiktok)',    label: 'TikTok' },
  instagram: { color: 'var(--color-cat-instagram)', label: 'Instagram' },
  news:      { color: 'var(--color-cat-news)',      label: 'Haber' },
  quiz:      { color: 'var(--color-cat-quiz)',      label: 'Quiz' },
  other:     { color: 'var(--color-cat-other)',     label: 'Diğer' },
}

export default function CategoryBadge({ category }: { category: LinkCategory }) {
  const s = STYLES[category]
  return (
    <span
      className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold uppercase tracking-wide border whitespace-nowrap"
      style={{
        color: s.color,
        borderColor: s.color + '55',
        background: s.color + '14',
      }}
    >
      <BrandIcon category={category} size={11} color={s.color} />
      {s.label}
    </span>
  )
}

export const CATEGORY_LABELS: Record<LinkCategory, string> = {
  youtube: 'YouTube',
  twitter: 'Twitter',
  tiktok: 'TikTok',
  instagram: 'Instagram',
  news: 'Haber',
  quiz: 'Quiz',
  other: 'Diğer',
}

// Twitter (X) başta — haber yayınında en sık kullanılan
export const ALL_CATEGORIES: LinkCategory[] = ['twitter', 'youtube', 'news', 'quiz', 'tiktok', 'instagram', 'other']
